import {DropdownMenu, type IconName} from '@wandb/components';
import React, {type ReactNode} from 'react';

import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';

type MenuItemProps = {
  children: ReactNode;
  // The menu content is portaled outside the run selector's
  // data-dd-privacy="allow" container, so items need an explicit name to avoid
  // reporting as "Masked Element" in RUM.
  'data-dd-action-name'?: string;
  icon?: IconName;
  id?: string;
  isDisabled?: boolean;
  onAction?: () => void;
};

export function MenuItem({
  children,
  'data-dd-action-name': ddActionName,
  icon,
  id,
  isDisabled,
  onAction,
}: MenuItemProps) {
  return (
    <DropdownMenu.Item
      data-dd-action-name={ddActionName}
      // A registered action name means the element is static UI text,
      // so it's safe to unmask in session replay too.
      data-dd-privacy={ddActionName ? DD_PRIVACY_ALLOW : undefined}
      id={id}
      onAction={onAction}
      isDisabled={isDisabled}>
      {icon ? <DropdownMenu.ItemDecorationLeft iconProps={{icon}} /> : null}
      <DropdownMenu.ItemLabel>{children}</DropdownMenu.ItemLabel>
    </DropdownMenu.Item>
  );
}
